document.addEventListener("DOMContentLoaded", () => {
  initSlider();
});

/**
 * スライダー設定
 */
function initSlider() {
  const swiper = new Swiper('.swiper-container', {
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    speed: 700,
    simulateTouch: true,
    loop:true,
  });
}